<template>
  <div class="page">
    <div style="width: 100%; display: flex; justify-content: center;">
      <TopBar></TopBar>
    </div>
    <div class="title">Answer these questions to pick an algorithm...</div>
    <div class="contents">
      <Question/>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import Question from "@/components/Question";
export default {
  name: "Quiz",
  components: {
    TopBar,
    Question
  },
}
</script>

<style scoped>
.page {
  width: 900px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

}
.title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
}

.contents{
  width: 100%;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>